export default "__VITE_ASSET__cb4cea3b__"